









































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import WorkerDto from '@/models/Workers/WorkerDto';
import CountryIso from '@/lib/countryIso';
import AddressUtils from '@/lib/addressUtils';
import UpdateAddressDetailsRequest from '@/models/Shared/UpdateAddressDetailsRequest';
import GeoPoint from '@/models/Shared/GeoPoint';
import IFullAddress from '@/models/Shared/IFullAddress';
import ajax from '@/lib/ajax';

@Component({
    name: 'WorkerAddressDetailsEdit'
})
export default class extends GiganautVueDialog {

  entity: WorkerDto = new WorkerDto();
  country: CountryIso = new CountryIso();
  addressSearchText = '';
  geocodingInProgress = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
      this.country = this.isoCountries.find((findIsoCountry: CountryIso) => findIsoCountry.code === this.entity.countryCode) || new CountryIso();
      this.addressSearchText = '';
    }
  }

  get isoCountries() {
    return AddressUtils.isoCountries();
  }

  get isTempWorker(): boolean {
    return this.entity.workTypes && this.entity.workTypes.includes('Temp');
  }

  get buildingNameNumberValidation(): string {
    return this.isTempWorker ? this.FieldValidationCodes.BuildingNameNumberRequired : this.FieldValidationCodes.BuildingNameNumber;
  }

  get streetRoadBlockValidation(): string {
    return this.isTempWorker ? this.FieldValidationCodes.StreetRoadBlockRequired : this.FieldValidationCodes.StreetRoadBlock;
  }

  get postZipCodeValidation(): string {
    return this.isTempWorker ? this.FieldValidationCodes.PostZipCodeRequired : this.FieldValidationCodes.PostZipCode;
  }

  get hasCoordinates(): boolean {
    return this.entity.geometry && (this.entity.geometry.lat !== 0 || this.entity.geometry.lng !== 0);
  }

  get hasAddressData(): boolean {
    return !!(
      this.entity.buildingNameNumber ||
      this.entity.streetRoadBlock ||
      this.entity.locality ||
      this.entity.cityTown ||
      this.entity.stateProvinceRegion ||
      this.entity.postZipCode
    );
  }

  get mapCenter() {
    return {
      lat: Number(this.entity.geometry?.lat) || 0,
      lng: Number(this.entity.geometry?.lng) || 0
    };
  }

  async getAddressData(addressData: any, placeData: any) {
    AddressUtils.populateGoogleMapsAddressData(addressData, placeData, this.entity as IFullAddress);
    // Mark as exact geo since user selected from Google autocomplete
    this.entity.isExactGeo = true;
    // Update country dropdown
    if (this.entity.countryCode) {
      const foundCountry = this.isoCountries.find((c: CountryIso) => c.code === this.entity.countryCode);
      if (foundCountry) {
        this.country = foundCountry;
      }
    }
  }

  async lookupCoordinates() {
    if (!this.hasAddressData) return;

    this.geocodingInProgress = true;

    try {
      const params = new URLSearchParams();
      if (this.entity.buildingNameNumber) params.append('buildingNameNumber', this.entity.buildingNameNumber);
      if (this.entity.streetRoadBlock) params.append('streetRoadBlock', this.entity.streetRoadBlock);
      if (this.entity.locality) params.append('locality', this.entity.locality);
      if (this.entity.cityTown) params.append('cityTown', this.entity.cityTown);
      if (this.entity.stateProvinceRegion) params.append('stateProvinceRegion', this.entity.stateProvinceRegion);
      if (this.entity.postZipCode) params.append('postZipCode', this.entity.postZipCode);
      if (this.country.code) params.append('countryCode', this.country.code);

      const response = await ajax.get(`/api/v1/agency/address/lookup-geo?${params.toString()}`);

      this.entity.geometry.lat = response.data.lat;
      this.entity.geometry.lng = response.data.lng;
      this.entity.isExactGeo = response.data.isExactGeo;
    } catch (error) {
      console.error('Geocoding error:', error);
    } finally {
      this.geocodingInProgress = false;
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAddressDetailsRequest();
    request.updatedAt = this.entity.updatedAt;
    request.buildingNameNumber = this.entity.buildingNameNumber;
    request.streetRoadBlock = this.entity.streetRoadBlock;
    request.locality = this.entity.locality;
    request.cityTown = this.entity.cityTown;
    request.stateProvinceRegion = this.entity.stateProvinceRegion;
    request.postZipCode = this.entity.postZipCode;
    request.countryCode = this.country.code;
    request.geometry = new GeoPoint();
    request.geometry.lat = Number(this.entity.geometry.lat);
    request.geometry.lng = Number(this.entity.geometry.lng);
    request.isExactGeo = this.entity.isExactGeo !== undefined ? this.entity.isExactGeo : true;
    request.workTypes = this.entity.workTypes || [];

    await WorkerDetailsModule.editAddressDetails(request)
    this.dialog = false;
  }
}
